import {FieldArray} from "formik";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import _ from "lodash";
import Button from "react-bootstrap/Button";
import React from "react";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import {FormattedMessage} from "react-intl";
import OtherPersonsListRow from "./OtherPersonsListRow";

/**
 * Liste von weiteren Personen, die zu dieser Einreichung mit bestimmten Rollen assoziiert werden.
 *
 * @param formikProps
 * @param widgetId
 * @param roles
 * @param personDataConfig
 * @param disabled
 * @returns {JSX.Element}
 * @constructor
 */
export const OtherPersonsList = ({formikProps, widgetId, roles, personDataConfig, disabled}) => {
    const personsRefs = formikProps.values.widgets[widgetId];

    const createEmptyPersonRef = () => {
        return {
            person: {
                id: _.uniqueId(),
                mainContact: {
                    salutation: '',
                    title: '',
                    firstName: '',
                    lastName: '',
                    phone: '',
                    email: '',
                    company: '',
                    street: '',
                    houseno: '',
                    postalCode: '',
                    city: '',
                    countryISOCode: '',
                    function: ''
                }
            }, role: null
        }
    };

    return <FieldArray name={`widgets.${widgetId}`}>
        {({push, remove}) =>
            <>
                <Row>
                    <Col>
                        <h2><FormattedMessage id="submission.form.persons.heading"/></h2>
                    </Col>
                </Row>
                <TransitionGroup>
                    {personsRefs && personsRefs.length > 0 && personsRefs.map((personRef, index) =>
                        <CSSTransition key={personRef.person.id} timeout={500} classNames="fade" key={`otherPerson-${index}`}>
                            <OtherPersonsListRow
                                widgetId={widgetId}
                                index={index}
                                remove={remove}
                                roles={roles}
                                personDataConfig={personDataConfig}
                                disabled={disabled}
                            />
                        </CSSTransition>
                    )}
                </TransitionGroup>
                {!disabled &&
                <Row>
                    <div className="text-right col">
                        <Button type="button"
                                variant="secondary"
                                onClick={() => push(createEmptyPersonRef())}
                                disabled={disabled}
                        >
                            <FormattedMessage id="submission.form.persons.button.add"/>
                        </Button>
                    </div>
                </Row>
                }
            </>
        }

    </FieldArray>;
};
